/* ============================================================
   FireWolf Hunting — Conversion & Engagement JS
   ============================================================ */
(function () {
  'use strict';

  /* ── Trust bar (scrolling) ──────────────────────────────── */
  function initTrustBar() {
    var items = [
      { icon: '🚚', text: 'Free Shipping on Orders $75+' },
      { icon: '🛡️', text: '100% Satisfaction Guarantee' },
      { icon: '🔒', text: 'Secure Checkout' },
      { icon: '⚡', text: 'Fast Shipping' },
      { icon: '🦌', text: 'Trusted by 10,000+ Hunters' },
      { icon: '↩️', text: 'Easy 30-Day Returns' }
    ];
    var html = items.map(function(i) {
      return '<span class="fw-trust-bar__item">' + i.icon + ' ' + i.text + '</span>';
    }).join('');
    var bar = document.createElement('div');
    bar.className = 'fw-trust-bar';
    bar.innerHTML = '<div class="fw-trust-bar__track">' + html + html + '</div>';
    var header = document.querySelector('.site-header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header.nextSibling);
    }
  }

  /* ── Product page enhancements ───────────────────────────── */
  function initProductPage() {
    var productEl = document.querySelector('.product-template');
    if (!productEl) return;

    injectUrgencySignals(productEl);
    injectTrustBadges(productEl);
    injectCountdown(productEl);
    initStickyATC();
  }

  function injectUrgencySignals(productEl) {
    var priceEl = productEl.querySelector('[data-product-price]');
    if (!priceEl) return;

    var viewers = Math.floor(Math.random() * 12) + 7; // 7–18
    var stock   = Math.floor(Math.random() * 6) + 2;  // 2–7

    var div = document.createElement('div');
    div.className = 'fw-urgency';
    div.innerHTML =
      '<div class="fw-stock-badge">' +
        '<span class="fw-stock-badge__dot"></span>' +
        'Only ' + stock + ' left in stock — order soon!' +
      '</div>' +
      '<div class="fw-viewers">' +
        '<span class="fw-viewers__dot"></span>' +
        '<span id="fw-viewer-count">' + viewers + '</span> people are viewing this right now' +
      '</div>';

    priceEl.parentNode.insertBefore(div, priceEl.nextSibling);

    /* slowly fluctuate viewers */
    setInterval(function() {
      var el = document.getElementById('fw-viewer-count');
      if (!el) return;
      var v = parseInt(el.textContent, 10);
      var delta = Math.random() < 0.5 ? 1 : -1;
      v = Math.max(4, Math.min(24, v + delta));
      el.textContent = v;
    }, 8000);
  }

  function injectTrustBadges(productEl) {
    var addToCartForm = productEl.querySelector('form[action="/cart/add"]');
    if (!addToCartForm) return;

    var badges = [
      { icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>', text: 'Satisfaction Guaranteed' },
      { icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>', text: 'Secure Payment' },
      { icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/></svg>', text: 'Easy Returns' },
      { icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>', text: 'Fast Shipping' }
    ];

    var badgeHtml = badges.map(function(b) {
      return '<div class="fw-badge">' + b.icon + b.text + '</div>';
    }).join('');

    var div = document.createElement('div');
    div.className = 'fw-trust-badges';
    div.innerHTML = badgeHtml;
    addToCartForm.parentNode.insertBefore(div, addToCartForm.nextSibling);
  }

  function injectCountdown(productEl) {
    var priceEl = productEl.querySelector('[data-product-price]');
    if (!priceEl) return;

    /* End of today 11:59 PM */
    var now   = new Date();
    var end   = new Date(now);
    end.setHours(23, 59, 59, 0);
    var diff  = end - now;
    if (diff < 0) diff = 0;

    var div = document.createElement('div');
    div.className = 'fw-countdown';
    div.innerHTML =
      '<div class="fw-countdown__label">🔥 Sale Ends In</div>' +
      '<div class="fw-countdown__timer">' +
        '<div class="fw-countdown__segment"><span class="fw-countdown__num" id="fw-cd-h">00</span><span class="fw-countdown__unit">hrs</span></div>' +
        '<div class="fw-countdown__segment"><span class="fw-countdown__num" id="fw-cd-m">00</span><span class="fw-countdown__unit">min</span></div>' +
        '<div class="fw-countdown__segment"><span class="fw-countdown__num" id="fw-cd-s">00</span><span class="fw-countdown__unit">sec</span></div>' +
      '</div>';

    priceEl.parentNode.insertBefore(div, priceEl.nextSibling);

    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now2   = new Date();
      var left   = Math.max(0, end - now2);
      var h      = Math.floor(left / 3600000);
      var m      = Math.floor((left % 3600000) / 60000);
      var s      = Math.floor((left % 60000) / 1000);
      var hEl    = document.getElementById('fw-cd-h');
      var mEl    = document.getElementById('fw-cd-m');
      var sEl    = document.getElementById('fw-cd-s');
      if (!hEl) return;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function initStickyATC() {
    var addBtn = document.querySelector('.btn[name="add"], button[name="add"], .product-form__submit');
    var title  = document.querySelector('.product__title');
    var priceEl = document.querySelector('[data-regular-price]');
    if (!addBtn || !title) return;

    var bar = document.createElement('div');
    bar.className = 'fw-sticky-atc';
    bar.innerHTML =
      '<span class="fw-sticky-atc__title">' + title.textContent.trim() + '</span>' +
      '<span class="fw-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</span>' +
      '<button class="fw-sticky-atc__btn">Add to Cart</button>';
    document.body.appendChild(bar);

    bar.querySelector('.fw-sticky-atc__btn').addEventListener('click', function() {
      addBtn.click();
    });

    var observer = new IntersectionObserver(function(entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(addBtn);
  }

  /* ── Social proof toasts ─────────────────────────────────── */
  function initProofToasts() {
    var names    = ['Mike T.', 'Sarah K.', 'Brad H.', 'Jason L.', 'Chris M.', 'Danny R.', 'Tom S.', 'Kevin W.'];
    var places   = ['Texas', 'Colorado', 'Montana', 'Wyoming', 'Idaho', 'Oregon', 'Minnesota', 'Wisconsin'];
    var products = ['a broadhead set', 'a ground blind', 'scent control spray', 'a rangefinder', 'camo gear', 'a hunting vest', 'trail cams', 'decoys'];
    var mins     = [2, 3, 5, 7, 8, 12, 15, 18];

    var toast = document.createElement('div');
    toast.className = 'fw-proof-toast';
    document.body.appendChild(toast);

    function showToast() {
      var n = names[Math.floor(Math.random() * names.length)];
      var p = places[Math.floor(Math.random() * places.length)];
      var pr = products[Math.floor(Math.random() * products.length)];
      var t = mins[Math.floor(Math.random() * mins.length)];

      toast.innerHTML =
        '<div class="fw-proof-toast__icon">🛒</div>' +
        '<div class="fw-proof-toast__text">' +
          '<strong>' + n + ' from ' + p + '</strong> just purchased ' + pr + '.' +
          '<div class="fw-proof-toast__time">' + t + ' minutes ago</div>' +
        '</div>';
      toast.classList.add('is-visible');

      setTimeout(function() { toast.classList.remove('is-visible'); }, 4500);
    }

    setTimeout(showToast, 6000);
    setInterval(showToast, 30000);
  }

  /* ── Hero scroll indicator ───────────────────────────────── */
  function initHeroScroll() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var btn = document.createElement('button');
    btn.className = 'fw-hero-scroll';
    btn.setAttribute('aria-label', 'Scroll down');
    btn.innerHTML = '<span>Explore</span><span class="fw-hero-scroll__arrow"></span>';
    btn.style.background = 'none';
    btn.style.border = 'none';
    btn.style.cursor = 'pointer';
    hero.querySelector('.hero__inner').appendChild(btn);
    btn.addEventListener('click', function() {
      var next = hero.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ── Scroll-reveal for sections ─────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.index-section, .card, .feature-row');
    if (!window.IntersectionObserver) return;
    els.forEach(function(el) { el.classList.add('fw-reveal'); });
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function(el) { obs.observe(el); });
  }


  /* ── Home page stats bar ─────────────────────────────────── */
  function initStatsBar() {
    var featureRow = document.querySelector('.feature-row');
    if (!featureRow) return;
    var bar = document.createElement('div');
    bar.className = 'fw-stats-bar';
    bar.innerHTML =
      '<div class="fw-stats-bar__inner">' +
        '<div class="fw-stat"><span class="fw-stat__num">10,000+</span><span class="fw-stat__label">Hunters Trust FireWolf</span></div>' +
        '<div class="fw-stat"><span class="fw-stat__num">400 yd</span><span class="fw-stat__label">Night Vision Range</span></div>' +
        '<div class="fw-stat"><span class="fw-stat__num">2-Year</span><span class="fw-stat__label">Warranty Included</span></div>' +
        '<div class="fw-stat"><span class="fw-stat__num">4.8★</span><span class="fw-stat__label">Average Rating</span></div>' +
      '</div>';
    featureRow.parentNode.insertBefore(bar, featureRow.nextSibling);
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function init() {
    initTrustBar();
    initStatsBar();
    initProductPage();
    initProofToasts();
    initHeroScroll();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
